import { IFormularioRespostaControle } from "@/interfaces/IFormularioRespostaControle";
import { api } from "@/services/api";
import { formularioControleRespostaActions } from "@/store/actions/formularioControleResposta";
import {
  getCountMunicipiosSynced,
  getFormularioControleRespostaIsSynced,
  getFormularioControleRespostaSynced,
  getMunicipiosSincronizados,
} from "@/store/reducers/formularioControleResposta";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { useNetworkStatus } from "./useNetworkStatus";

export const useFormularioRespostaControle = () => {
  const { isOnline } = useNetworkStatus();
  const { user } = useAuth();
  const appDispatch = useDispatch();
  const listaFormularioControleResposta = useSelector(
    getFormularioControleRespostaSynced
  );
  const { sync, removeMunicipio } = formularioControleRespostaActions;
  const synced = useSelector(getFormularioControleRespostaIsSynced);
  const countMunicipiosSynced = useSelector(getCountMunicipiosSynced);
  const municipiosSincronizados = useSelector(getMunicipiosSincronizados);

  const sincronizarFormulariosControleRespostas = (
    items: IFormularioRespostaControle[]
  ) => {
    appDispatch(sync(items));
  };

  const removerMunicipio = (municipioId: number) => {
    appDispatch(removeMunicipio(municipioId));
  };

  const getFormularioRespostaControle = async (municipioId: number) => {
    const { data } = await api.get<IFormularioRespostaControle[]>(
      `/formularios-respostas-controle/municipio/${municipioId}`,
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  const getFormulariosRespostaControle = async (municipioId: number) => {
    if (isOnline) {
      const dados = await getFormularioRespostaControle(municipioId);
      return dados;
    }

    return listaFormularioControleResposta.filter(
      (f) => f.municipio.id === municipioId
    );
  };

  return {
    getFormularioRespostaControle,
    sincronizarFormulariosControleRespostas,
    removerMunicipio,
    listaFormularioControleResposta,
    municipiosSincronizados,
    synced,
    getFormulariosRespostaControle,
    countMunicipiosSynced,
  };
};
